import BasePrevenApiClient from './baseApi'

/**
 * Mesclagem manual de cadastros duplicados de equipamento (mesmo número de
 * série). O cadastro mais antigo é mantido e o mais recente é ocultado.
 */
class EquipmentMergeApi extends BasePrevenApiClient {
  static get shared() {
    return super.shared
  }

  _path() {
    return this._getFullPath('/equipment/api/merge/equipment')
  }

  /** Os dois cadastros lado a lado: `{ kept, hidden }`. */
  preview(token, ids) {
    this._clearMemos()
    return this._get(this._path(), {
      authToken: token,
      params: { ids: ids.join(',') },
    }).then(({ data }) => data)
  }

  merge(token, ids) {
    return this._post(
      this._path(),
      { equipment_ids: ids },
      { authToken: token }
    ).then(({ data }) => data)
  }
}

export default EquipmentMergeApi
